import { advancePrivateEpoch } from './privacyEpoch';

/* Alles wat privé is en dít apparaat lokaal bewaart, op één plek.

   Bij een echte sessie-intrekking moet dat allemaal weg. Eerder wisten we
   alleen de bootstrapcache; de Today Pass, de gelezen-tot-hier-cursor en de
   outbox met bijbehorende blobs bleven staan — inhoud van iemand die geen
   toegang meer heeft.

   Eén lijst, zodat een nieuwe cache niet stilletjes buiten het opruimen valt. */
export const PRIVATE_LOCAL_KEYS = [
  "gorodn_adventure_cache",
  "gorodn_adventure_draft",
  "gorodn_adventure_pending",
  "gorodn_boot_cache",     // laatst bekende bootstrap (offline shell)
  "gorodn_todaypass",      // Today Pass, offline-cache van Станция
  "gorodn_seq",            // «pока тебя не было»-cursor
  "gorodn_known_session",  // hint dat dit apparaat een sessie kende
  "gorodn_hint_bld",       // eerste-gebruik-hint (niet privé, wel van deze sessie)
  "gorodn_world_cache",    // veilige wereldindex voor offline terugkijken
] as const;

export const PRIVATE_IDB_NAME = "gorodn10";   // outbox + blobs

/** Wis de privéopslag die deze applicatie beheert. De algemene HTTP-cache en
 *  eerder opgeslagen downloads zijn niet via deze routine te verwijderen. Faalt nooit hard: opruimen mag het
 *  afsluiten zelf niet blokkeren. */
export async function wipePrivateData(): Promise<void> {
  // Invalidate in-flight writes synchronously, before imports/IndexedDB awaits.
  advancePrivateEpoch();
  for (const key of PRIVATE_LOCAL_KEYS) {
    try { localStorage.removeItem(key); } catch { /* privémodus */ }
  }
  try {
    const drafts = Array.from({ length: localStorage.length }, (_, i) => localStorage.key(i))
      .filter((key): key is string => !!key && key.startsWith("gorodn_draft_"));
    for (const key of drafts) localStorage.removeItem(key);
  } catch { /* Private storage may be unavailable. */ }
  try { sessionStorage.removeItem("gorodn_redeeming"); } catch { /* idem */ }

  /* De outbox bevat mutaties én media-blobs. Die horen bij de ingetrokken
     sessie en mogen niet blijven wachten op een volgende gebruiker.

     Eerst de inhoud legen: `deleteDatabase` wordt geblokkeerd zolang de app
     nog een verbinding openhoudt, en dan blijft alles gewoon staan. Daarna
     proberen we de database alsnog te verwijderen -- lukt dat niet, dan is
     hij in elk geval leeg. */
  try { const { outboxWipe } = await import("./outbox"); await outboxWipe(); }
  catch { /* geen outbox: niets te legen */ }
  await new Promise<void>((resolve) => {
    try {
      const req = indexedDB.deleteDatabase(PRIVATE_IDB_NAME);
      req.onsuccess = () => resolve();
      req.onerror = () => resolve();
      req.onblocked = () => resolve();      // open verbinding: leeg is genoeg
      setTimeout(resolve, 1200);            // nooit blijven hangen
    } catch { resolve(); }
  });
}
